import {Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-upload-progress-header',
  imports: [TranslocoPipe, NgClass],
  templateUrl: './upload-document-progress-header.component.html',
})
export class UploadDocumentProgressHeaderComponent {
  readonly totalCountMandatory = input.required<number>();
  readonly completedCountMandatory = input.required<number>();

  protected readonly percentage = computed(() => {
    const total = this.totalCountMandatory();
    if (total === 0) return 0;
    return Math.round((this.completedCountMandatory() / total) * 100);
  });

  protected readonly progressBarClass = computed(() => {
    const p = this.percentage();
    if (p === 100) return 'bg-(--color-green)';
    if (p > 0) return 'bg-(--color-blue)';
    return 'bg-(--color-red)';
  });
}
